import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";

@Component({
  selector: "product-hot-point-form",
  templateUrl: "./product-hot-point-form.component.html",
  styleUrls: ["./product-hot-point-form.component.scss"],
})
export class ProductHotPointFormComponent {
  @Input() form: FormGroup;

  constructor(public ft: FormToolsService) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-hot-point-form/product-hot-point-form.component.ts